import React, { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';

import Default from 'layouts/Default';
import Loader from 'modules/loader/components/Loader';

function Public(props) {
  const { component, layout, ...rest } = props;
  const Layout = layout ? lazy(() => import(`../layouts/${layout}`)) : Default;
  const Component = lazy(() => import(`../${component}`));
  const renderLoader = Loader;

  return (
    <Route
      {...rest}
      render={(props) => (
        <Suspense fallback={renderLoader()}>
          <Layout>
            <Component {...props} />
          </Layout>
        </Suspense>
      )}
    />
  );
}

export default Public;
